import AsyncLoader from 'commons/components/AsyncLoader';

export * from './constants';

export default AsyncLoader(() => import('./Information'));
